import { makeObservable, observable, flow, action, computed } from "mobx";
import { toast } from "sonner";
import { api } from "@/lib/services";
import { ApiRoutes } from "@/lib/routes";
import { Check, Heart } from "lucide-react";

import { LoaderIcon } from "@/components/icons/LoaderIcon";
import AddItemToWatchlistStoreSchema from "@/areas/inventory/schemas/AddItemToWatchlistStoreSchema";

export default class AddItemToWatchlistStore {
  visible = false;
  processing = false;

  constructor(parentStore) {
    makeObservable(this, {
      visible: observable,
      processing: observable,
      show: action,
      hide: action,
      toggle: action,
      save: flow,
      canCreate: computed,
    });

    this.parentStore = parentStore;
  }

  get canCreate() {
    return this.parentStore.parentStore.authenticationStore.isAdmin;
  }

  show() {
    this.visible = true;
  }

  hide() {
    this.visible = false;
  }

  toggle(visible) {
    this.visible = visible === true ? true : visible === false ? false : !this.visible;
  }

  *save(data, options) {
    const parseResult = AddItemToWatchlistStoreSchema.safeParse(data);
    if (!parseResult.success) {
      return parseResult;
    }

    let toastId;
    try {
      this.processing = true;
      toastId = toast(
        <div className="flex w-full items-center gap-2">
          <Heart className="size-4 text-primary" />
          <div className="flex flex-grow flex-col">
            <span className="text-base">Watchlist</span>
            <span>Adding item to your watchlist</span>
          </div>
          <LoaderIcon className="h-5 w-5 text-primary" />
        </div>,
        {
          duration: Infinity,
        }
      );

      const response = yield api.post(ApiRoutes.forItemWatchlist(data.id));
      this.visible = false;
      toast(
        <div className="flex w-full items-center gap-2">
          <Heart className="size-4 text-primary" />
          <div className="flex flex-grow flex-col">
            <span className="text-base">Watchlist</span>
            <span>Item added to watchlist successfully</span>
          </div>
          <Check className="h-5 w-5 text-green-600" />
        </div>,
        {
          id: toastId,
          duration: 4000,
        }
      );
      return { success: true, data: response.data };
    } catch (e) {
      toast.error("Error while adding item to watchlist", {
        description: e.response?.data?.message ?? e.response?.message ?? "Unexpected error, please try again later.",
        id: toastId,
        duration: 4000,
      });
      return { success: false, error: e };
    } finally {
      this.processing = false;
    }
  }
}
